import { render, staticRenderFns } from "./MemberTeamDetails.vue?vue&type=template&id=79d2aece&scoped=true"
import script from "./MemberTeamDetails.vue?vue&type=script&lang=js"
export * from "./MemberTeamDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberTeamDetails.vue?vue&type=style&index=0&id=79d2aece&prod&lang=less&scoped=true"
import style1 from "./MemberTeamDetails.vue?vue&type=style&index=1&id=79d2aece&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d2aece",
  null
  
)

export default component.exports